module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"en":{"tariffInactive":"Your tariff is inactive","expiredTariffText":"To gain access to all the functions of your tariff, you need to make a payment.","expiredTariffButton":"Pay the tariff"}}')
  delete Component.options._Ctor
}
